module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mainsection hero is-fullheight is-dark"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container userinfowrapper"
  }, [_c('nav', {
    staticClass: "is-flex mt2"
  }, [_vm._m(0), _c('user-info', {
    staticClass: "userinfo",
    attrs: {
      "id": _vm.userId
    }
  })], 1)]), _c('div', {
    staticClass: "container flex-auto"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": {
        name: 'intro'
      },
      "exact": "exact"
    }
  }, [_vm._v("Chercher des suggestions")]), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "active-class": "is-active",
      "to": {
        name: 'new-ean13'
      },
      "exact": "exact"
    }
  }, [_vm._v("Ajouter un titre absent")])], 1)])]), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._t("default")], 2)]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-iem mr2",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "_margin-icon",
    attrs: {
      "src": require("@/assets/logo-noir.svg"),
      "width": "80px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-foot"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', [_c('li', [_c('a', [_vm._v("Copyright 2017 Robert veut lire")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-325fbdeb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/layouts/default-layout.vue
// module id = 1360
// module chunks = 1